import { useSelector } from "react-redux";
import {
  DEFAULT_BANNER_IMAGE,
  DEFAULT_PROFILE_IMAGE,
} from "../utils/brandAssets";

const useUserHook = () => {
  const user = useSelector((state) => state.user.userDetails);
  const getProfilePic = (bannerImage = false) => {
    if (bannerImage) {
      return user?.coverPic || DEFAULT_BANNER_IMAGE;
    }
    return user?.profilePic || DEFAULT_PROFILE_IMAGE;
  };

  return { getProfilePic, user };
};
export default useUserHook;
